import { useState, useRef, useEffect } from 'react';
import { useLanguage, LANGUAGES } from '../i18n/LanguageContext';

const LanguageSwitcher = ({ variant = 'nav' }) => {
  const { language, switchLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = LANGUAGES.find(l => l.code === language);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  if (variant === 'landing') {
    return (
      <div className="lang-toggle-landing" ref={ref} data-testid="language-switcher">
        <button onClick={() => setOpen(!open)} className="lang-toggle-btn-landing" data-testid="lang-toggle-btn">
          <i className="fa-solid fa-globe"></i>
          <span>{current?.label}</span>
          <i className={`fa-solid fa-chevron-${open ? 'up' : 'down'}`} style={{ fontSize: '0.65rem' }}></i>
        </button>
        {open && (
          <div className="lang-dropdown-landing">
            {LANGUAGES.map((lang) => (
              <button
                key={lang.code}
                onClick={() => { switchLanguage(lang.code); setOpen(false); }}
                className={`lang-dropdown-item ${language === lang.code ? 'lang-dropdown-active' : ''}`}
                data-testid={`lang-btn-${lang.code}`}
              >
                {lang.label}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="lang-toggle" ref={ref} data-testid="language-switcher">
      <button onClick={() => setOpen(!open)} className="lang-toggle-btn" data-testid="lang-toggle-btn">
        <i className="fa-solid fa-globe"></i>
        <span>{current?.label}</span>
        <i className={`fa-solid fa-chevron-${open ? 'up' : 'down'}`} style={{ fontSize: '0.65rem' }}></i>
      </button>
      {open && (
        <div className="lang-dropdown">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              onClick={() => { switchLanguage(lang.code); setOpen(false); }}
              className={`lang-dropdown-item ${language === lang.code ? 'lang-dropdown-active' : ''}`}
              data-testid={`lang-btn-${lang.code}`}
            >
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
